// src/utils/photoCategories.js
//
// The guided photo categories the driver app records, mirrored for the web.
//
// The driver app stamps a `category` onto each entry of pickupPhotosMetadata /
// deliveryPhotosMetadata (see loadmemo-mob src/constants/photoCategories.js).
// Keep the keys below identical to that file — they are matched by string.
//
// Photos taken before guided capture existed carry no category at all, and
// there will be years of them. Those are never hidden: they fall through to
// "Other photos" so an old BOL still shows everything it always did.

export const PHOTO_CATEGORY_ORDER = [
  { key: 'odometer_fuel', label: 'Odometer / Fuel' },
  { key: 'keys',          label: 'Keys' },
  { key: 'vin_plate',     label: 'VIN plate' },
  { key: 'sunroof',       label: 'Sunroof' },
  { key: 'damage',        label: 'Damage' },
  { key: 'general',       label: 'Other photos' },
];

const FALLBACK_KEY = 'general';

export const getPhotoCategoryLabel = (key) =>
  PHOTO_CATEGORY_ORDER.find(c => c.key === key)?.label || 'Other photos';

/**
 * Group a leg's photos into labelled sections, in the order drivers shoot them.
 *
 * Returns only non-empty groups, so a load with no damage shows no empty
 * "Damage" heading. Any photo whose category is missing or unrecognised is
 * folded into "Other photos" rather than dropped.
 */
export function groupPhotosByCategory(photos = []) {
  const known = new Set(PHOTO_CATEGORY_ORDER.map(c => c.key));
  const buckets = new Map(PHOTO_CATEGORY_ORDER.map(c => [c.key, []]));

  photos.forEach(photo => {
    const key = known.has(photo?.category) ? photo.category : FALLBACK_KEY;
    buckets.get(key).push(photo);
  });

  return PHOTO_CATEGORY_ORDER
    .map(c => ({ ...c, photos: buckets.get(c.key) }))
    .filter(group => group.photos.length > 0);
}
